import queries from '@apis/queries';
import Header from '@components/Header';
import { datadogRum } from '@datadog/browser-rum';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Params {
    cardId: string;
}

const PrepaidCardChargeCompleteActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { t } = useTranslation('prepaidCard');
    const { cardId } = params;
    const { replace, push } = useFlow();
    const toast = useToast();
    const queryClient = useQueryClient();
    useEffect(() => {
        if (cardId) {
            if (import.meta.env.MODE !== 'development') {
                datadogRum.addAction('prepaidChargeChargeComplete', {
                    cardId,
                });
            }
            queryClient.invalidateQueries({ queryKey: queries.userPrepaidCard._def })
                .then(() => {
                    replace('MainActivity', {}, { animate: false });
                    push('MyPrepaidCardActivity', {});
                    toast.success(t('chargeComplete.success'));
                }).catch(() => {
                    replace('MainActivity', {}, { animate: false });
                    push('MyPrepaidCardActivity', {});
                    toast.error(t('chargeComplete.error'));
                });
        } else {
            toast.error(t('chargeComplete.failed'));
        }
    }, [cardId]);
    return (
        <AppScreen>
            <Header title={t('chargeComplete.title')} />
        </AppScreen>
    );
};

export default PrepaidCardChargeCompleteActivity;
